module.exports = __webpack_public_path__ + "static/media/kk-ab_suite.64ff5edd.png";